var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 160,
    viewBox: "0 0 157 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16471_22971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3741 104.045L67.0455 93.3736L79.6124 93.7246L80.8059 92.5311C87.1947 86.0722 96.7427 83.7554 105.378 86.6338C111.065 88.5294 116.541 90.8462 121.806 93.6544L154.171 110.504C156.278 111.627 156.769 114.506 155.154 116.191C150.942 120.614 144.483 121.807 138.937 119.28L118.156 109.661L118.296 114.997C118.577 129.038 113.452 142.588 104.044 152.979L99.8318 158.034C99.7616 158.034 56.655 125.668 56.3741 104.045Z",
    fill: "#6DD0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.041 159.859C90.5649 160.842 85.4398 157.121 84.5973 151.645L80.5956 123.703C80.0339 119.912 82.4912 116.401 86.2121 115.559C90.0734 114.646 94.005 117.104 94.9177 120.965L102.008 150.732C102.991 154.874 100.253 159.087 96.041 159.859Z",
    fill: "#6DD0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6332 152.839L77.6468 152.136C72.4515 151.715 68.3796 147.503 68.169 142.237L67.0457 110.855C67.0457 107.064 69.9241 103.905 73.7152 103.554C77.717 103.203 81.1571 106.151 81.5783 110.153L86.6332 152.839Z",
    fill: "#6DD0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.875 109.24L111.346 111.065C100.113 114.225 89.5819 110.434 83.1932 100.886L81.9294 98.99",
    stroke: "#080717",
    strokeWidth: 1.01729,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1376 14.322L36.9982 31.4507L129.261 53.7476L133.4 36.6189L41.1376 14.322Z",
    fill: "#FFB83A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.25 30.4128L27.172 84.5286L113.771 105.457L126.849 51.3409L40.25 30.4128Z",
    fill: "#FFCD74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.248 53.777L36.9974 31.4514",
    stroke: "#282D33",
    strokeWidth: 1.31075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.169 15.6548C110.433 10.3893 106.992 6.10673 101.587 6.03652C96.2509 5.96632 90.9854 10.1085 89.6515 15.2335L87.3347 25.0624L97.4444 25.1326C102.71 24.9922 107.975 20.85 109.169 15.6548Z",
    stroke: "#282D33",
    strokeWidth: 1.31075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2407 6.73881C73.5746 1.47335 78.5592 -0.773254 83.3332 1.61376C88.1073 4.00077 90.9155 10.0385 89.7922 15.2338L87.335 24.9924L78.3486 20.429C73.715 17.9718 70.9769 11.8639 72.2407 6.73881Z",
    stroke: "#282D33",
    strokeWidth: 1.31075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3355 25.063L70.486 94.7076",
    stroke: "#282D33",
    strokeWidth: 1.31075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.846 24.6421L132.267 29.3459",
    stroke: "#282D33",
    strokeWidth: 1.31075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.054 28.7134L127.634 31.7322",
    stroke: "#282D33",
    strokeWidth: 1.31075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.456 37.0685L126.089 36.6472",
    stroke: "#282D33",
    strokeWidth: 1.31075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.527 44.791L128.546 41.2104",
    stroke: "#282D33",
    strokeWidth: 1.31075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.882 47.3885L133.461 42.7549",
    stroke: "#282D33",
    strokeWidth: 1.31075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.605 43.3166L138.024 40.3679",
    stroke: "#282D33",
    strokeWidth: 1.31075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.202 35.0325L139.568 35.4537",
    stroke: "#282D33",
    strokeWidth: 1.31075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.131 27.2395L137.182 30.82",
    stroke: "#282D33",
    strokeWidth: 1.31075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9772 136.27L64.3076 135.568C59.7442 135.146 56.2339 131.355 56.0935 126.792L55.1106 94.216C55.1106 90.4249 57.4274 87.2656 60.5165 86.9146C63.746 86.5636 66.5542 89.5122 66.835 93.514L70.9772 136.27Z",
    fill: "#6DD0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1481 127.775L57.4271 127.284C52.0915 126.581 48.1599 122.018 48.1599 116.682L48.2301 89.8636C48.3003 86.4937 50.5469 83.7557 53.2148 83.5451C56.0932 83.3345 58.5504 86.0725 58.6908 89.5828L61.1481 127.775Z",
    fill: "#6DD0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8075 152.838C84.6671 152.417 84.5969 152.066 84.5267 151.645L80.5249 123.703C79.9633 119.912 82.4205 116.401 86.1414 115.559C90.0028 114.646 93.9343 117.104 94.847 120.965L101.938 150.732",
    stroke: "#080717",
    strokeWidth: 1.01729,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8884 135.778L66.9757 110.784C66.9757 106.993 69.8542 103.834 73.6453 103.483C77.6471 103.132 81.0872 106.081 81.5084 110.082L82.4211 117.665",
    stroke: "#080717",
    strokeWidth: 1.01729,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0935 126.862L55.1106 94.2861C55.1106 90.495 57.4274 87.3357 60.5165 86.9847C63.746 86.6336 66.5542 89.5823 66.835 93.584L68.0987 107.134",
    stroke: "#080717",
    strokeWidth: 1.01729,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1856 62.9744C27.5897 62.9744 28.713 64.1679 28.713 65.572C28.713 66.9761 27.5195 68.0994 26.1154 68.0994C24.7113 68.0994 23.5879 66.9059 23.5879 65.5018C23.5879 64.0977 24.7113 62.9744 26.1856 62.9744ZM26.9579 32.0134C26.8876 32.8559 26.1154 33.4877 25.2027 33.4175C24.3602 33.3473 23.7284 32.5751 23.7986 31.6624C23.8688 30.8199 24.641 30.1881 25.5537 30.2583C26.4664 30.3987 27.0983 31.1709 26.9579 32.0134ZM3.29835 55.2517C5.05351 55.2517 6.45763 57.3579 6.45763 59.8853C6.38742 62.4127 4.91309 64.4487 3.15794 64.4487C1.40278 64.4487 -0.00134277 62.3425 -0.00134277 59.8151C0.0688635 57.2175 1.54319 55.1815 3.29835 55.2517Z",
    fill: "#FFD30A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0106 59.6047C28.0106 59.6047 36.2247 44.3699 31.5209 40.9298C25.6236 36.577 19.2348 46.8271 21.4112 51.3905C23.5876 55.9539 23.2366 41.9829 16.567 43.1062C11.3717 43.9487 11.7227 50.5481 28.0106 59.6047ZM126.089 79.122C126.089 79.122 124.123 67.1869 128.054 67.6082C131.986 68.0294 133.039 73.8565 130.441 75.6117C127.774 77.3668 130.652 70.627 135.005 71.5397C139.428 72.3822 140.411 76.8754 126.089 79.122Z",
    fill: "#FFB4FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16471_22971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156.068,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBox);
export default __webpack_public_path__ + "static/media/gift-box.01d7d44cdf72c093953e5ece8305f670.svg";
export { ForwardRef as ReactComponent };